import gql from "graphql-tag";

export const CHANGE_CONTENT_FROM_FILE = gql`
  mutation changeContentFromFile($where: [ChangeContentFromFileInput]!) {
    changeContentFromFile(where: $where)
  }
`;